import { gain } from "./constants";
import getBandwidth from "util/eqMathHelpers/getBandwidth";
import { EQTypes } from "./types";

interface Props {
  q: number;
  centerFreq: number;
  type: EQTypes;
  freqRange: {
    min: number;
    max: number;
  };
}

export default function generateLineData({
  q,
  centerFreq,
  type,
  freqRange,
}: Props): { x: number; y: number }[] {
  const { lowerFreq, upperFreq } = getBandwidth(centerFreq, q);

  if (type === "boost") {
    return [
      {
        x: freqRange.min,
        y: gain.cut,
      },

      {
        x: lowerFreq,
        y: gain.cut,
      },

      {
        x: centerFreq,
        y: gain.boost,
      },

      {
        x: upperFreq,
        y: gain.cut,
      },

      {
        x: freqRange.max,
        y: gain.cut,
      },
    ];
  }

  if (type === "cut") {
    return [
      {
        x: freqRange.min,
        y: gain.boost,
      },

      {
        x: lowerFreq,
        y: gain.boost,
      },

      {
        x: centerFreq,
        y: gain.cut,
      },

      {
        x: upperFreq,
        y: gain.boost,
      },

      {
        x: freqRange.max,
        y: gain.boost,
      },
    ];
  }

  if (type === "hipass") {
    return [
      {
        x: freqRange.min,
        y: gain.cut,
      },
      {
        x: lowerFreq,
        y: gain.cut,
      },
      {
        x: centerFreq,
        y: gain.boost,
      },
      {
        x: freqRange.max,
        y: gain.boost,
      },
    ];
  }

  if (type === "lopass") {
    return [
      {
        x: freqRange.min,
        y: gain.boost,
      },
      {
        x: centerFreq,
        y: gain.boost,
      },
      {
        x: upperFreq,
        y: gain.cut,
      },
      {
        x: freqRange.max,
        y: gain.cut,
      },
    ];
  }

  return [];
}
